import React from 'react';
import 'react-dom';
import '../../_rollupPluginBabelHelpers-2e5b701d.js';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import '../../index-930c2100.js';
import '../../hooks/useActivify.js';
import '../../index-efb29065.js';
import '../../key_codes-a5a2b85e.js';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import '../../style-inject.es-1f59c1d0.js';
import '@styled-system/layout';
import '@styled-system/flexbox';
import '@styled-system/position';
import '@styled-system/shadow';
import '../box.js';
import { g as getObjectValue } from '../../util-cc00ee1d.js';
import '../../index.esm-f8e9e79f.js';
import '@styled-system/grid';
import '@styled-system/background';
import { I as IconWrapper } from '../../IconWrapper-eb05d1ed.js';

var ContentManagementIcon = function ContentManagementIcon(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99506 21H18.0049C20.1978 21 22 19.3939 22 17.3977V6.60149C22 4.60601 20.1978 3 18.0049 3H5.99506C3.80218 3 2 4.60601 2 6.60149V17.3985C2 19.394 3.80218 21 5.99506 21ZM3.28724 6.60149C3.28724 5.2744 4.49133 4.17702 5.99506 4.17702H18.0049C19.5087 4.17702 20.7128 5.2744 20.7128 6.60149V17.3977C20.7128 18.7249 19.5087 19.8222 18.0049 19.8222H5.99506C4.49133 19.8222 3.28724 18.7249 3.28724 17.3977V6.60149Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep),
    stroke: props.theme.colors.grey.deep,
    strokeWidth: "0.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0712 9.01455H10.1115C9.81072 9.01455 9.56689 8.66033 9.56689 8.22334C9.56689 7.78634 9.81072 7.43213 10.1115 7.43213H18.0712C18.372 7.43213 18.6158 7.78634 18.6158 8.22334C18.6158 8.66033 18.372 9.01455 18.0712 9.01455Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77214 9.36192C6.00717 9.36192 5.38464 8.74008 5.38464 7.97595C5.38464 7.21182 6.00717 6.59082 6.77214 6.59082C7.5371 6.59082 8.15963 7.21266 8.15963 7.97679C8.15963 8.74091 7.5371 9.36192 6.77214 9.36192ZM6.77214 7.678C6.60791 7.678 6.47469 7.81191 6.47469 7.97595C6.47469 8.13999 6.60708 8.2739 6.77214 8.2739C6.9372 8.2739 7.06957 8.13999 7.06957 7.97595C7.06957 7.81191 6.93636 7.678 6.77214 7.678Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0712 13.1649H10.1115C9.81072 13.1649 9.56689 12.8107 9.56689 12.3737C9.56689 11.9368 9.81072 11.5825 10.1115 11.5825H18.0712C18.372 11.5825 18.6158 11.9368 18.6158 12.3737C18.6158 12.8107 18.372 13.1649 18.0712 13.1649Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77214 13.5126C6.00717 13.5126 5.38464 12.8908 5.38464 12.1267C5.38464 11.3625 6.00717 10.7407 6.77214 10.7407C7.5371 10.7407 8.15963 11.3625 8.15963 12.1267C8.15963 12.8908 7.5371 13.5126 6.77214 13.5126ZM6.77214 11.8287C6.60791 11.8287 6.47469 11.9626 6.47469 12.1267C6.47469 12.2907 6.60791 12.4246 6.77214 12.4246C6.93636 12.4246 7.06957 12.2907 7.06957 12.1267C7.06957 11.9626 6.93636 11.8287 6.77214 11.8287Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0712 17.3153H10.1115C9.81072 17.3153 9.56689 16.9612 9.56689 16.5241C9.56689 16.0872 9.81072 15.7329 10.1115 15.7329H18.0712C18.372 15.7329 18.6158 16.0872 18.6158 16.5241C18.6158 16.9612 18.372 17.3153 18.0712 17.3153Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77214 17.6631C6.00717 17.6631 5.38464 17.0413 5.38464 16.278C5.38464 15.5139 6.00717 14.8921 6.77214 14.8921C7.5371 14.8921 8.15963 15.5139 8.15963 16.278C8.15963 17.0413 7.5371 17.6631 6.77214 17.6631ZM6.77214 15.9792C6.60791 15.9792 6.47469 16.1131 6.47469 16.2772C6.47469 16.4412 6.60791 16.5743 6.77214 16.5743C6.93636 16.5743 7.06957 16.4404 7.06957 16.2772C7.06957 16.1131 6.93636 15.9792 6.77214 15.9792Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep)
  })));
};
ContentManagementIcon.propTypes = {
  iconColor: PropTypes.string
};
ContentManagementIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ContentManagementIcon",
  "props": {
    "iconColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
var ContentManagementIcon$1 = withTheme(ContentManagementIcon);

export default ContentManagementIcon$1;
